import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../helpers/translate.helper';
import { useOpenFreshchat } from '../../hooks/useOpenFreshchat';
import { useRole } from '../../hooks/useRole';
import { useShortcutMenu } from '../../ShortcutMenu/hooks/useShortcutMenu';
import { Box } from '../../ui/Box';

import { SidebarMenuItem } from './SidebarMenuItem';
import { SidebarMenuNavigationItem } from './SidebarMenuNavigationItem';

interface SidebarMenuItemsProps {
    closeMenu: () => void;
}

export const SidebarMenuItems = ({ closeMenu }: SidebarMenuItemsProps) => {
    const role = useRole();
    const openFreshchat = useOpenFreshchat();
    const { openGroupContextSelection } = useShortcutMenu();

    const { addErrorToast } = useToasts();

    const handleContactSupport = () => {
        closeMenu();
        openFreshchat();
    };

    const handleChangelog = () => {
        if (window.Productlane) {
            closeMenu();
            window.Productlane.toggle();
        } else {
            closeMenu();
            addErrorToast(translate('global.genericError'));
        }
    };

    return (
        <>
            {role.isSuperAdmin() ? (
                <Box paddingY={4} paddingX={4} borderBottom="1px solid" borderColor="border.subtle">
                    <SidebarMenuItem
                        onClick={() => {
                            closeMenu();
                            openGroupContextSelection();
                        }}
                    >
                        {translate('shortcutMenu.changeGroupContext')}
                    </SidebarMenuItem>
                </Box>
            ) : null}

            <Box paddingY={4} paddingX={4} borderBottom="1px solid" borderColor="border.subtle">
                <SidebarMenuNavigationItem to="/me" closeMenu={closeMenu}>
                    {translate('navigation.personalDetails')}
                </SidebarMenuNavigationItem>

                {role.hasAnyAdminRights() ? (
                    <SidebarMenuNavigationItem to="/settings" closeMenu={closeMenu}>
                        {translate('global.settings')}
                    </SidebarMenuNavigationItem>
                ) : null}
            </Box>

            <Box paddingY={4} paddingX={4}>
                {!role.isSuperAdmin() ? (
                    <SidebarMenuItem onClick={handleContactSupport}>
                        {translate('navigation.messageUs')}
                    </SidebarMenuItem>
                ) : null}

                <SidebarMenuItem onClick={handleChangelog}>{translate('navigation.changelog')}</SidebarMenuItem>
            </Box>

            <Box paddingY={4} paddingX={4} borderTop="1px solid" borderColor="border.subtle">
                <SidebarMenuNavigationItem to="/logout" closeMenu={closeMenu}>
                    {translate('navigation.signOut')}
                </SidebarMenuNavigationItem>
            </Box>
        </>
    );
};
